// extracted by mini-css-extract-plugin
export default {"progressBarContainer":"ProgressBar_solo_progressBarContainer__ShQy2","progressBar":"ProgressBar_solo_progressBar__brV84"};